<template>
  <v-navigation-drawer
    app
    permanent
  >
    <v-list
      nav
      density="comfortable"
    >
      <v-list-item
        v-for="(deposit, index) in deposits"
        :key="index"
        :disabled="deposit.status !== 'open'"
        :title="deposit.name"
        :prepend-icon="deposit.status === 'open' ? 'mdi-folder' : 'mdi-folder-lock'"
        @click="goToDeposit(deposit)"
      />
    </v-list>

    <template #append>
      <v-list nav>
        <v-list-item
          title="Sign out"
          prepend-icon="mdi-logout"
          @click="signOut"
        />
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { on, off } from '@/utils/bus'

export default {
  name: 'DepositsSidebar',
  props: {
    deposits: { type: Array, default: () => [] },
  },
  data () {
    return {
      tree: [],
    }
  },
  mounted () {
    on('dirs', this.setDirs)
  },
  beforeUnmount () {
    off('dirs', this.setDirs)
  },
  methods: {
    setDirs (dirs) {
      if (dirs) this.tree = dirs
    },
    goToDeposit (deposit) {
      if (deposit.status !== 'open') return
      this.$router.push({
        name: 'DepositFileHome',
        params: {
          deposit_id: deposit.id,
          deposit_name: deposit.name,
          depositor: deposit.depositor['custom:identityid'],
        }
      })
    },
    signOut () {
      this.$router.push('/signout')
    }
  }
}
</script>

<style>
.deposits { width: 100% }
.fixedBottom { position: fixed !important; bottom: 0 !important; width: 100% }
</style>
